import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import Accordion from "../../../common/accordion";
import useJetliftCollapseFacade from "../../../../facade/jetlift/collapse/collapse.facade";
import useInputValidations from "../InputValidations";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import { LABELS } from "../../../../constants/labels/jetlift/jetlift.labels";

const Well: React.FC = () => {
    const {
        getdefaultCollapse,
        handleCollapseChange,
    } = useJetliftCollapseFacade();
    const { sectionsData, renderField, wellIPRrenderFields } = useInputValidations();
    const [form, setForm] = useState<{ [key: string]: string }>({});
    const { register, control } = useFormContext();
    const { wellInput } = useAppSelector((state) => state?.jetlift?.well);

    const handleChange = (label: string, value: string) => {
        setForm((prev) => ({ ...prev, [label]: value }));
    };

    return (
        <div className="flex flex-col gap-[16px]">
            {sectionsData?.well?.map((section, secIdx) => {
                return (
                    <>
                        {section?.section === LABELS?.surfaceConditions && (
                            <div
                                key={secIdx}
                                className="flex flex-col"
                            >
                                <Accordion
                                    title={section.section}
                                    isOpen={getdefaultCollapse(section?.section) ?? false}
                                    onToggle={() => handleCollapseChange(!getdefaultCollapse(section?.section), section?.section)}
                                    content={
                                        <div className="flex flex-col gap-[16px] p-[12px]">
                                            {section.fields.map((field, idx) => {
                                                return (
                                                    <div key={idx}>
                                                        {
                                                            renderField(field, form, handleChange, register, control)
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                />
                            </div>
                        )}
                    </>
                )
            })}
            {wellIPRrenderFields(
                LABELS?.iprType,
                form,
                handleChange,
                register,
                control,
                wellInput?.inflowTypeLstVal?.toString() || ""
            )}
            {sectionsData?.well?.map((section, secIdx) => {
                return (
                    <>
                        {section?.section === LABELS?.settingDepth && (
                            <div
                                key={secIdx}
                                className="flex flex-col"
                            >
                                <Accordion
                                    title={section.section}
                                    isOpen={getdefaultCollapse(section?.section) ?? false}
                                    onToggle={() => handleCollapseChange(!getdefaultCollapse(section?.section), section?.section)}
                                    content={
                                        <div className="flex flex-col gap-[16px] p-[12px]">
                                            {section.fields.map((field, idx) => {
                                                return (
                                                    <div key={idx}>
                                                        {
                                                            renderField(field, form, handleChange, register, control)
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                />
                            </div>
                        )}
                    </>
                )
            })}
        </div>
    );
};

export default Well;